import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { GraphQlEnum } from '../utils/Enums'
import { updateData } from '../utils/Functions'

import * as AllAtoms from '../recoil/atoms'
import { useSetRecoilState } from 'recoil'

const useFetchQuery = (props) => {
	const { segment, backendPageInfo, variables, action, subscriptionVariables, subscription } = props
	const segmentAtom = AllAtoms[GraphQlEnum[segment]?.fetch?.[action]?.atom]
	const query = GraphQlEnum[segment]?.fetch?.[action]?.queryName
	const outputFunction = GraphQlEnum[segment]?.fetch?.[action]?.queryOutput
	const setAtom = useSetRecoilState(segmentAtom)
	const variablesPacket = variables ? GraphQlEnum[segment]?.fetch?.[action]?.getVariables({ ...variables }) : {}
	const paginatedOptions = backendPageInfo
		? {
				...variablesPacket,
				options: {
					...variablesPacket?.options,
					limit: backendPageInfo.pageSize,
					offset: (backendPageInfo.pageNo - 1) * backendPageInfo?.pageSize,
				},
		  }
		: null

	const { data, loading, error, fetchMore, subscribeToMore } = useQuery(query, {
		variables: backendPageInfo ? paginatedOptions : variables && variablesPacket,
		fetchPolicy: 'network-only', // Used for first execution
		nextFetchPolicy: 'cache-and-network', // Used for subsequent executions
	})

	useEffect(() => {
		if (subscription) {
			return subscribeToMore({
				document: GraphQlEnum[segment]?.listen?.[action]?.subscriptionName,
				...(subscriptionVariables && { variables: subscriptionVariables }),
				updateQuery: (prev, { subscriptionData }) => {
					return updateData({ prev, subscriptionData, segment, action, setAtom })
				},
			})
		}
	}, [segment, action, subscription]) //eslint-disable-line

	useEffect(() => {
		fetchMore({ paginatedOptions })
	}, [backendPageInfo]) //eslint-disable-line

	useEffect(() => {
		if (error) {
			throw error
		}
		data && setAtom(data?.[outputFunction])
	}, [data, error]) //eslint-disable-line

	return { data, loading }
}

export default useFetchQuery
